<template>
  <div>
    <md-content v-if="!this.add_section">
      <md-list class="md-double-line">
        <md-list-item v-for="(section, index) in sections" :key="section.id" @click="linkToSection(section)">
          <md-icon v-if="section.icon" class="md-primary">{{ section.icon }}</md-icon>
          <div class="md-list-item-text">
            <span>{{ section.name }}</span>
            <span>{{ section.description }}</span>
          </div>
          <md-button class="md-icon-button md-list-action" v-on:click="edit(index)">
            <md-icon>edit</md-icon>
          </md-button>
          <md-button class="md-icon-button md-list-action" v-on:click="promptDeleteSection(index)">
            <md-icon>delete</md-icon>
          </md-button>
        </md-list-item>
      </md-list>
      <md-button class="md-icon-button md-raised md-primary" v-on:click="handleAddSectionEvent">
        <md-icon>add</md-icon>
      </md-button>
    </md-content>
    <SectionEdit :section="section" @save="handleSaveSectionEvent" @cancel="handleCancelEvent" v-if="this.add_section"/>
    <md-dialog-confirm
      :md-active.sync="confirmDelete"
      :md-content="deletePrompt"
      md-confirm-text="Yes"
      md-cancel-text="No"
      @md-cancel="onCancelDeleteSection"
      @md-confirm="onDeleteSection" />
  </div>
</template>

<script>
import Vue from 'vue'
import SectionEdit from '@/components/admin/SectionEdit.vue'
import { mapActions, mapState } from 'vuex'
export default {
  name: "HandbookSectionList",
  components: {
    SectionEdit
  },
  data (){
    return {
      add_section: false,
      selection: 0,
      deletePrompt: '',
      confirmDelete: false,
      sectionToDelete: {},
      sectionBackup: {}
    }
  },
  computed: {
    ...mapState({
      sections: s => s.handbook.sections
    }),
    section () {
      if(this.sections.length == 0) return {}
      else return this.sections[this.selection]
    }
  },
  methods: {
    ...mapActions([
      'addSection',
      'getSections',
      'saveSection',
      'removeSection',
      'deleteSection',
      'selectSection',
      'resetSection'
    ]),
    handleAddSectionEvent() {
      this.addSection()
      this.selection = this.sections.length - 1
      this.add_section = true
    },
    handleSaveSectionEvent() {
      this.saveSection(this.section).then( () => {
        this.add_section = false
      })
    },
    handleCancelEvent() {
      if(this.section.id){
        this.resetSection(this.sectionBackup)
      }else {
        this.removeSection(this.section)
      }
      this.add_section = false
    },
    edit(index) {
      this.selection = index
      this.sectionBackup = Object.assign({}, this.section)
      this.add_section = true
    },
    linkToSection(section) {
      this.selectSection(section)
    },
    onDeleteSection(){
      this.deleteSection(this.sectionToDelete)
      this.sectionToDelete = {}
    },
    onCancelDeleteSection(){
      this.sectionToDelete = {}
    },
    promptDeleteSection(index) {
      this.sectionToDelete = this.sections[index]
      this.deletePrompt =  `Are you sure you want to delete '${this.sectionToDelete.name}'?`,
      this.confirmDelete =  true
    }
  },
  beforeMount () {
    this.getSections()
  }
}
</script>
